import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "antd";
import NetworkApi from "../../network/networkApi";

const STORAGE_KEY = "cultivation_registration_notice_2026";

const CultivationRegistrationNotice: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [closeDate, setCloseDate] = useState("2026.07.20");

  const loadNotice = useCallback(async () => {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }

    const response = await NetworkApi.requestGet(
      "/api/cultivation/registration/status"
    );
    if (response.resultCode !== 200 || !response.result?.closeDate) {
      return;
    }

    if (!response.result.open) {
      return;
    }

    const formattedCloseDate = response.result.closeDate.replace(/-/g, ".");
    setCloseDate(formattedCloseDate);
    setVisible(true);
  }, []);

  useEffect(() => {
    loadNotice();
  }, [loadNotice]);

  const handleClose = () => {
    setVisible(false);
    sessionStorage.setItem(STORAGE_KEY, "true");
  };

  return (
    <Modal
      open={visible}
      onOk={handleClose}
      onCancel={handleClose}
      okText="За"
      cancelButtonProps={{ style: { display: "none" } }}
      width={640}
      centered
      title={<div style={{ textAlign: "center" }}>Мэдэгдэл</div>}
    >
      <div style={{ width: "100%" }}>
        <p style={{ textAlign: "center" }}>
          2026 оны тариалалтын мэдээг системд оруулахыг {closeDate}-ны өдрөөр
          тасалбар болгож байгаа тул хугацаандаа мэдээллээ оруулна уу.
        </p>
        <p style={{ textAlign: "center" }}>
          {closeDate}-ны өдрөөс хойш тариалалтын мэдээ бүртгэх үйлдлийг хаах
          болохыг мэдэгдье.
        </p>
        <p style={{ textAlign: "center", fontWeight: 500 }}>
          ХХААХҮЯ - ГАЗАР ТАРИАЛАНГИЙН БОДЛОГЫН ХЭРЭГЖИЛТИЙГ ЗОХИЦУУЛАХ ГАЗАР
        </p>
        {/*<div style={{ textAlign: "center" }}>*/}
        {/*  <span>*/}
        {/*    Холбоо барих: <a href="tel:51263408">51263408</a>*/}
        {/*  </span>*/}
        {/*</div>*/}
      </div>
    </Modal>
  );
};

export default CultivationRegistrationNotice;
